import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface DocumentReviewCardProps {
    approving: boolean;
    rejecting: boolean;
    onApprove: () => void;
    onRequestReject: () => void;
    translate: (key: string) => string;
}

export function DocumentReviewCard({ approving, rejecting, onApprove, onRequestReject, translate }: DocumentReviewCardProps) {
    return (
        <Card variant="outlined">
            <CardContent>
                <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
                    {translate('documents.docReview')}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {translate('documents.docsReadyForReview')}
                </Typography>
                <Stack direction="row" spacing={1}>
                    <Button size="small" variant="contained" color="success" sx={{ color: 'white' }} disabled={approving || rejecting} onClick={onApprove}>
                        {approving ? translate('common.saving') : translate('documents.approveDoc')}
                    </Button>
                    <Button size="small" variant="outlined" color="error" disabled={approving || rejecting} onClick={onRequestReject}>
                        {translate('documents.rejectDoc')}
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
}
